<div class="w-full flex items-center gap-2 overflow-x-auto pb-2 xl:pb-0">
    <!-- Day Pass Segmented Control -->
    <div class="inline-flex bg-gray-100 rounded-lg p-1 shrink-0">
        <button *ngFor="let option of dateOptions; trackBy: trackByFn" type="button"
            class="text-sm px-3 py-1.5 rounded-md whitespace-nowrap transition-all"
            [ngClass]="selectedOption?.value === option.id && selectedOption?.type === 'daypass'
                ? 'bg-white text-primary-600 shadow-sm font-semibold'
                : 'text-gray-600 hover:text-gray-900'"
            (click)="onSelectDateOption(option.id)">
            {{ option.name }}
        </button>
    </div>
    <!-- Date Range Picker -->
    <div class="w-72 shrink-0">
        <mat-form-field class="w-full">
            <button class="w-full text-sm border rounded-lg py-1.5 pl-3 pr-10 relative text-left transition-colors"
                [ngClass]="selectedOption?.type === 'date-range'
                    ? 'bg-primary-50 text-primary-600 border-primary-300 font-semibold'
                    : 'text-gray-600 hover:text-gray-900'"
                (click)="dateRangePicker.open()">
                <div class="whitespace-nowrap">{{dateRangeLabel}}</div>
                <div class="absolute inset-0 justify-end pr-2 flex items-center hover:cursor-pointer"
                    (click)="dateRangePicker.open()">
                    <fa-icon [icon]="faCalendar"
                        [ngClass]="selectedOption?.type === 'date-range' ? 'text-primary-600' : 'text-secondary-500'"
                        class="text-lg flex justify-center items-center"></fa-icon>
                </div>
            </button>
            <mat-date-range-input class="!hidden" id="dateRangePicker" [rangePicker]="dateRangePicker" [max]="maxDate">
                <input matStartDate [(ngModel)]="selectedStartDate" [max]="maxDate"
                    [ngModelOptions]="{standalone: true}">
                <input matEndDate [(ngModel)]="selectedEndDate" [max]="maxDate" [ngModelOptions]="{standalone: true}"
                    (dateChange)="onDateRangeSelected()">
            </mat-date-range-input>
            <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
        </mat-form-field>
    </div>
</div>